// Italian formatting helpers: date GG/MM/AAAA, euro, numbers.
export function formatNumber(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("it-IT");
}

export function formatCompact(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("it-IT", { notation: "compact", maximumFractionDigits: 1 });
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function formatEuroCents(cents) {
  return (cents / 100).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}

export function formatPct(n) {
  if (n === null || n === undefined) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${Number(n).toLocaleString("it-IT", { maximumFractionDigits: 2 })}%`;
}
